import { X, MapPin } from "lucide-react";
import { AlertBanner } from "./AlertBanner";
import { MetricsGrid } from "./MetricsGrid";
import { HourlyTimeline } from "./HourlyTimeline";
import { DailyForecast } from "./DailyForecast";
import { AqiCard } from "./AqiCard";
import { temp, tempUnit, locationLabel, locationDetail } from "../lib/weather";

export const DetailPanel = ({ open, onClose, data, units, accent, liveData }) => {
  if (!open || !data) return null;
  return (
    <aside className="windy-panel fade-up" data-testid="detail-panel">
      <div className="flex items-center justify-between gap-3 px-5 py-4 border-b border-border/60 sticky top-0 glass z-10">
        <div className="min-w-0">
          <div className="flex items-center gap-1.5 text-sm font-bold truncate">
            <MapPin className="w-4 h-4 text-primary shrink-0" />
            {locationLabel(data.location)}
          </div>
          <div className="text-xs text-muted-foreground num">
            {locationDetail(data.location) ? `${locationDetail(data.location)} · ` : ""}{temp(data.current.temp, units)}{tempUnit(units)} · <span className="capitalize">{data.current.condition.description}</span>
          </div>
        </div>
        <button
          data-testid="close-detail-button"
          onClick={onClose}
          className="h-9 w-9 grid place-items-center glass rounded-xl hover:border-primary/40"
          title="Tutup"
        >
          <X className="w-4 h-4" />
        </button>
      </div>

      <div className="p-4 space-y-4">
        <AlertBanner alerts={data.alerts} />
        <HourlyTimeline hourly={data.hourly} offset={data.location.timezone_offset} units={units} accent={accent} />
        <MetricsGrid current={data.current} units={units} />
        <DailyForecast daily={data.daily} offset={data.location.timezone_offset} units={units} accent={accent} />
        <AqiCard aqi={data.aqi} />
        <footer className="text-center text-[11px] text-muted-foreground py-2">
          KayongWeather · Data {liveData ? "real-time OpenWeatherMap" : "simulasi (demo)"} · Radar RainViewer · Angin Open-Meteo
        </footer>
      </div>
    </aside>
  );
};
